var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { updateSellerWalletPlanSuccess, updateSellerWalletPlanFailure, UPDATE_SELLER_WALLET_PLAN_REQUEST, } from "../../actions";
import APIIN from "@/utils/APIIN";
const onUpdateWalletPlanData = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            APIIN.postCompany(`/company/admin/billing/tier?tenantId=${(_a = action.payload) === null || _a === void 0 ? void 0 : _a.tenantId}&tenantTier=${(_b = action.payload) === null || _b === void 0 ? void 0 : _b.tenantTier}`, {})
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateWalletPlanDataWorker(action) {
    try {
        const data = yield call(onUpdateWalletPlanData, action);
        yield put(updateSellerWalletPlanSuccess(data));
    }
    catch (error) {
        yield put(updateSellerWalletPlanFailure(error));
    }
}
export function* watchUpdateWalletPlanData() {
    yield takeLatest(UPDATE_SELLER_WALLET_PLAN_REQUEST, updateWalletPlanDataWorker);
}
